// @ts-ignore - import from .js file
import * as ActionTypes from "constants/ActionTypes"

const AT = ActionTypes as any;

export const userSignUp = (user: any) => {
  return {
    type: AT.SIGNUP_USER,
    payload: user
  }
}

export const userSignIn = (user: any) => {
  return {
    type: AT.SIGNIN_USER,
    payload: user
  }
}

export const userSignOut = () => {
  return {
    type: AT.SIGNOUT_USER
  }
}

export const userSignUpSuccess = (authUser: any) => {
  return {
    type: AT.SIGNUP_USER_SUCCESS,
    payload: authUser
  }
}

export const userSignInSuccess = (authUser: any, fromLogin = false) => {
  return {
    type: AT.SIGNIN_USER_SUCCESS,
    payload: authUser,
    fromLogin,
  }
}

export const userSignOutSuccess = () => {
  return {
    type: AT.SIGNOUT_USER_SUCCESS,
  }
}

export const userVerify = (value: any) => {
  return {
    type: AT.VERIFY_USER,
    payload: value
  }
}

export const userVerifySuccess = (value: any) => {
  return {
    type: AT.VERIFY_USER_SUCCESS,
    payload: value
  }
}

export const verifyOTP = (value: any) => {
  return {
    type: AT.VERIFY_OTP,
    payload: value
  }
}

export const verifyOTPSuccess = (value: any) => {
  return {
    type: AT.VERIFY_OTP_SUCCESS,
    payload: value
  }
}

export const showAuthMessage = (message: any) => {
  return {
    type: AT.SHOW_MESSAGE,
    payload: message
  }
}

export const setInitUrl = (url: string) => {
  return {
    type: AT.INIT_URL,
    payload: url
  }
}

export const showAuthLoader = () => {
  return {
    type: AT.ON_SHOW_LOADER,
  }
}

export const hideMessage = () => {
  return {
    type: AT.HIDE_MESSAGE
  }
}

export const resetProcessStatus = () => {
  return {
    type: AT.RESET_PROCESS_STATUS
  }
}

export const hideAuthLoader = () => {
  return {
    type: AT.ON_HIDE_LOADER,
  }
}

export const resetPassword = (value: any) => {
  /* Value is {password:'',confirm:'',uid:''} */
  return {
    type: AT.RESET_PASSWORD,
    payload: value
  }
}

export const changeWorkShift = (value: any) => {
  return {
    type: AT.CHANGE_WORK_SHIFT,
    payload: value
  }
}

export const changeWorkShiftSuccess = (value: any) => {
  return {
    type: AT.CHANGE_WORK_SHIFT_SUCCESS,
    payload: value
  }
}

export const resetPasswordSuccess = () => {
  return {
    type: AT.RESET_PASSWORD_SUCCESS
  }
}

export const authProcessSuccess = (value: any) => {
  return {
    type: AT.AUTH_PROCESS_SUCCESS,
    payload: value
  }
}

// export const verifyToken = (value)=>{
//   return{
//     type:VERIFY_TOKEN,
//     payload:value
//   }
// }

export const requestResetUser = (value: any) => {
  /* Value is { "action_type" : "","user_name" :  "","email" :  "" } */
  return {
    type: AT.REQUEST_RESET_USER,  // Process
    payload: value
  }
}

export const requestResetUserSuccess = (value: any) => {
  return {
    type: AT.REQUEST_RESET_USER_SUCCESS,
    payload: value
  }
}

export const clearRequestResetUser = () => {
  return {
    type: AT.REQUEST_RESET_USER_CLEAR
  }
}

export const invalidRequestResetUser = (value: any) => {
  return {
    type: AT.REQUEST_RESET_USER_INVALID,
    payload: value
  }
}

export const checkSession = (navigatePath: string) => {
  return {
    type: AT.CHECK_SESSION,
    payload: navigatePath
  }
}

export const checkSessionSuccess = (value: any) => {
  return {
    type: AT.CHECK_SESSION_SUCCESS,
    payload: value
  }
}

export const updateUserPermission = (value: any) => {
  return {
    type: AT.UPDATE_USER_PERMISSION,
    payload: value
  }
}

export const acceptPolicySuccess = () => {
  return {
    type: AT.ACCEPT_POLICY_SUCCESS,
  }
}


